export default function (entity, extra) {

    console.log('debugging :', 'component', '\'' + 'timeout' + '\'',  '(ending)');
    console.log(extra);
    console.log('debugging :', 'entity', '\'' + entity.name + '\'');
    console.log(entity);
};
